export enum ZendeskTeam {
  Risk = 'risk',
  Compliance = 'compliance',
  External = 'external'
}
